import Spinner from "react-bootstrap/Spinner"
import "./index.scss"
import i18n from "i18n"

// A component indicating that something is loading.
// This is pretty dynamically styled, and will work in most containers.
export default function Loading({ title = i18n.t("loading") }) {
  return (
    <div className="Loading">
      <Spinner animation="border" variant="primary" />
      <p>{title}</p>
    </div>
  )
}
